import reduce from 'lodash/fp/reduce'


const fields = {
    SKIP_ENROLLMENT: 'skipEnrollment'
}

export const initialValues = reduce((acc, field) => ({
    ...acc
}), {}, Object.values(fields))

export default fields
